// extracted by mini-css-extract-plugin
export default {"container":"style_container__wEmAl","main":"style_main__+X8-s","loginBox":"style_loginBox__zUs+a","jaguarLogo":"style_jaguarLogo__qdMCC"};